import {type} from '@ngrx/signals';
import {event, EventCreator} from '@ngrx/signals/events';
import {CqrsEvent} from '@scalified-monorepo/shared';

export const CqrsEventFactory = <T extends CqrsEvent>(eventType?: string): EventCreator<string, T> =>
  event(`[CQRS] Event${eventType ? ' ' + eventType : ''}`, type<T>());

export const CqrsEventErrorType = 'CqrsEventFailed';
